import config from "appConfig";
import { LayoutComponents } from "packages/lesson/dist/@types";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 4,
        rows: 4,
        colSpan: {
          "0:0": 2,
        },
        rowSpan: {
          "0:0": 4,
        },
        colsSize: [1, 1, 0.1, 1],
        rowsSize: [0.5, 0.5, 0.5, 0.5],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/scenario-2.svg`,
                  },
                },
              },
            },
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `Sound insulation target between technical room and classroom: 50 dB`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      fontWeight: 700,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-end",
                  justifyContent: "flex-start",
                  paddingBottom: "5%",
                },
              },
            },
          ],
          [
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/smile-happy.svg`,
                    styles: {
                      width: "20px",
                      height: "20px",
                    },
                  },
                },
                styles: {
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-size: 16px; font-weight: 700;">SPACE SAVING</span><br />Neither the technical room nor the classroom need to be reduced in space to integrate this access door.`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      fontWeight: 400,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
          [
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/smile-sad.svg`,
                    styles: {
                      width: "20px",
                      height: "20px",
                    },
                  },
                },
                styles: {
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-size: 16px; font-weight: 700;">COST SAVING</span><br />These back-to-back doors require a good acoustic performance (35 dB or higher) to meet the sound insulation target.`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      textAlign: "left",
                      fontWeight: 400,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
          [
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/smile-happy-dark.svg`,
                    styles: {
                      width: "20px",
                      height: "20px",
                    },
                  },
                },
                styles: {
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-size: 16px; font-weight: 700;">ACOUSTIC INSULATION OBTAINED ON SITE</span><br />The sound insulation can be obtained with these two acoustic doors. However, the on site performance highly depends on their implementation (perfect seal compression, absence of even the smallest air gaps etc).`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      fontWeight: 400,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
